// // // import React, { useEffect, useState } from 'react';
// // // import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// // // import Navbar from './components/Navbar';
// // // import Hero from './components/Hero';
// // // import About from './components/About';
// // // import './index.css';
// // // import Offer from './components/Offer';
// // // import Pricing from './components/Pricing';
// // // import Attractions from './components/Attractions';
// // // import AttractionsDetails from './components/AttractionsDetails';
// // // import Contact from './components/Contact';
// // // import Footer from './components/Footer';

// // // const ScrollHandler = ({ children }) => {
// // //   const [activeSection, setActiveSection] = useState('');
// // //   const location = useLocation();

// // //   useEffect(() => {
// // //     const sections = ['hero', 'about', 'offer', 'attractions', 'contact'];

// // //     const handleScroll = () => {
// // //       if (location.pathname === '/') {
// // //         const scrollPosition = window.scrollY + 100;
// // //         for (let id of sections) {
// // //           const el = document.getElementById(id);
// // //           if (el && el.offsetTop <= scrollPosition && (el.offsetTop + el.offsetHeight) > scrollPosition) {
// // //             setActiveSection(id);
// // //             break;
// // //           }
// // //         }
// // //       }
// // //     };

// // //     window.addEventListener('scroll', handleScroll);
// // //     return () => window.removeEventListener('scroll', handleScroll);
// // //   }, [location]);

// // //   return (
// // //     <>
// // //       <Navbar activeSection={activeSection} />
// // //       {children}
// // //       <Footer />
// // //     </>
// // //   );
// // // };

// // // const HomePage = () => {
// // //   return (
// // //     <>
// // //       <div id="hero"><Hero /></div>
// // //       <div id="about"><About /></div>
// // //       <div id="offer"><Offer /></div>
// // //       <div id="attractions"><Attractions /></div>
// // //       <div id="contact"><Contact /></div>
// // //     </>
// // //   );
// // // };

// // // function App() {
// // //   return (
// // //     <Router>
// // //       <div className="font-sans text-gray-800 bg-[#edece8]">
// // //         <Routes>
// // //           <Route path="/" element={
// // //             <ScrollHandler>
// // //               <HomePage />
// // //             </ScrollHandler>
// // //           } />
// // //           <Route path="/cennik" element={
// // //             <>
// // //               <Navbar />
// // //               <Pricing />
// // //               <Footer />
// // //             </>
// // //           } />
// // //           <Route path="/atrakcje" element={
// // //             <>
// // //               <Navbar />
// // //               <AttractionsDetails />
// // //               <Footer />
// // //             </>
// // //           } />
// // //         </Routes>
// // //       </div>
// // //     </Router>
// // //   );
// // // }

// // // export default App;

// // import React, { useEffect, useState } from 'react';
// // import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// // import Navbar from './components/Navbar';
// // import Hero from './components/Hero';
// // import About from './components/About';
// // import './index.css';
// // import Offer from './components/Offer';
// // import Pricing from './components/Pricing';
// // import Attractions from './components/Attractions';
// // import AttractionsDetails from './components/AttractionsDetails';
// // import Contact from './components/Contact';
// // import Footer from './components/Footer';
// // import AdminAboutPanel from './components/AdminAboutPanel';
// // import AdminHeroPanel from './components/AdminHeroPanel';
// // import AdminOfferPanel from './components/AdminOfferPanel';
// // import AdminPricingPanel from './components/AdminPricingPanel';
// // import AdminAttractionsPanel from './components/AdminAttractionsPanel';
// // import AdminContactPanel from './components/AdminContactPanel';
// // import AdminPanelWithStyles from './components/AdminPanelWithStyles';

// // const ScrollHandler = ({ children }) => {
// //   const [activeSection, setActiveSection] = useState('');
// //   const location = useLocation();

// //   useEffect(() => {
// //     const sections = ['hero', 'about', 'offer', 'attractions', 'contact'];

// //     const handleScroll = () => {
// //       if (location.pathname === '/') {
// //         const scrollPosition = window.scrollY + 100;
// //         for (let id of sections) {
// //           const el = document.getElementById(id);
// //           if (el && el.offsetTop <= scrollPosition && (el.offsetTop + el.offsetHeight) > scrollPosition) {
// //             setActiveSection(id);
// //             break;
// //           }
// //         }
// //       }
// //     };

// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, [location]);

// //   return (
// //     <>
// //       <Navbar activeSection={activeSection} />
// //       {children}
// //       <Footer />
// //     </>
// //   );
// // };

// // const HomePage = () => {
// //   return (
// //     <>
// //       <div id="hero"><Hero /></div>
// //       <div id="about"><About /></div>
// //       <div id="offer"><Offer /></div>
// //       <div id="attractions"><Attractions /></div>
// //       <div id="contact"><Contact /></div>
// //     </>
// //   );
// // };

// // function App() {
// //   return (
// //     <Router>
// //       <div className="font-sans text-gray-800 bg-[#edece8]">
// //         <Routes>
// //           <Route path="/" element={
// //             <ScrollHandler>
// //               <HomePage />
// //             </ScrollHandler>
// //           } />
// //           <Route path="/cennik" element={
// //             <>
// //               <Navbar />
// //               <Pricing />
// //               <Footer />
// //             </>
// //           } />
// //           <Route path="/atrakcje" element={
// //             <>
// //               <Navbar />
// //               <AttractionsDetails />
// //               <Footer />
// //             </>
// //   } />
// //             <Route path="/admin/AdminAboutPanel" element={<AdminAboutPanel />} />
// //             <Route path="/admin/AdminHeroPanel" element={<AdminHeroPanel />} />
// //             <Route path="/admin/AdminOfferPanel" element={<AdminOfferPanel />} />
// //             <Route path="/admin/AdminPricingPanel" element={<AdminPricingPanel />} />
// //             <Route path="/admin/AdminAttractionsPanel" element={<AdminAttractionsPanel />} />
// //             <Route path="/admin/AdminContactPanel" element={<AdminContactPanel />} />
// //             <Route path="/admin/AdminPanelWithStyles" element={<AdminPanelWithStyles />} />
          

// //         </Routes>
// //       </div>
// //     </Router>
// //   );
// // }

// // export default App;

// // App.js
// import React, { useEffect, useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import Hero from './components/Hero';
// import About from './components/About';
// import './index.css';
// import Offer from './components/Offer';
// import Pricing from './components/Pricing';
// import Attractions from './components/Attractions';
// import AttractionsDetails from './components/AttractionsDetails';
// import Contact from './components/Contact';
// import Footer from './components/Footer';
// import AdminAboutPanel from './components/AdminAboutPanel';
// import AdminHeroPanel from './components/AdminHeroPanel';
// import AdminOfferPanel from './components/AdminOfferPanel';
// import AdminPricingPanel from './components/AdminPricingPanel';
// import AdminAttractionsPanel from './components/AdminAttractionsPanel';
// import AdminContactPanel from './components/AdminContactPanel';
// import AdminPanelWithStyles from './components/AdminPanelWithStyles';

// const ScrollHandler = ({ children }) => {
//   const [activeSection, setActiveSection] = useState('');
//   const location = useLocation();

//   useEffect(() => {
//     const sections = ['hero', 'about', 'offer', 'attractions', 'contact'];

//     const handleScroll = () => {
//       if (location.pathname === '/') {
//         const scrollPosition = window.scrollY + 100;
//         for (let id of sections) {
//           const el = document.getElementById(id);
//           if (el && el.offsetTop <= scrollPosition && (el.offsetTop + el.offsetHeight) > scrollPosition) {
//             setActiveSection(id);
//             break;
//           }
//         }
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [location]);

//   return (
//     <>
//       <Navbar activeSection={activeSection} />
//       {children}
//       <Footer />
//     </>
//   );
// };

// const HomePage = () => {
//   return (
//     <>
//       <div id="hero"><Hero /></div>
//       <div id="about"><About /></div>
//       <div id="offer"><Offer /></div>
//       <div id="attractions"><Attractions /></div>
//       <div id="contact"><Contact /></div>
//     </>
//   );
// };

// // Dodaj ten nowy komponent dla podstron
// const PageLayout = ({ children }) => {
//   return (
//     <>
//       <Navbar activeSection="" /> {/* Przekazujemy pusty activeSection */}
//       {children}
//       <Footer />
//     </>
//   );
// };

// function App() {
//   return (
//     <Router>
//       <div className="font-sans text-gray-800 bg-[#edece8]">
//         <Routes>
//           <Route path="/" element={
//             <ScrollHandler>
//               <HomePage />
//             </ScrollHandler>
//           } />
//           <Route path="/cennik" element={
//             <PageLayout>
//               <Pricing />
//             </PageLayout>
//           } />
//           <Route path="/atrakcje" element={
//             <PageLayout>
//               <AttractionsDetails />
//             </PageLayout>
//           } />
//           <Route path="/admin/AdminAboutPanel" element={<AdminAboutPanel />} />
//           <Route path="/admin/AdminHeroPanel" element={<AdminHeroPanel />} />
//           <Route path="/admin/AdminOfferPanel" element={<AdminOfferPanel />} />
//           <Route path="/admin/AdminPricingPanel" element={<AdminPricingPanel />} />
//           <Route path="/admin/AdminAttractionsPanel" element={<AdminAttractionsPanel />} />
//           <Route path="/admin/AdminContactPanel" element={<AdminContactPanel />} />
//           <Route path="/admin/AdminPanelWithStyles" element={<AdminPanelWithStyles />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

// import React, { useEffect, useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import Hero from './components/Hero';
// import About from './components/About';
// import './index.css';
// import Offer from './components/Offer';
// import Pricing from './components/Pricing';
// import Attractions from './components/Attractions';
// import AttractionsDetails from './components/AttractionsDetails';
// import Contact from './components/Contact';
// import Footer from './components/Footer';
// import AdminAboutPanel from './components/AdminAboutPanel';
// import AdminHeroPanel from './components/AdminHeroPanel';
// import AdminOfferPanel from './components/AdminOfferPanel';
// import AdminPricingPanel from './components/AdminPricingPanel';
// import AdminAttractionsPanel from './components/AdminAttractionsPanel';
// import AdminContactPanel from './components/AdminContactPanel';
// import AdminPanelWithStyles from './components/AdminPanelWithStyles';

// const ScrollHandler = ({ children }) => {
//   const [activeSection, setActiveSection] = useState('');
//   const location = useLocation();

//   useEffect(() => {
//     // Obsługa automatycznego przewijania po nawigacji z innej strony
//     if (location.state?.scrollTo) {
//       const element = document.getElementById(location.state.scrollTo);
//       if (element) {
//         setTimeout(() => {
//           element.scrollIntoView({ behavior: 'smooth' });
//         }, 100);
//         // Wyczyść stan, aby nie przewijać za każdym razem
//         window.history.replaceState({}, document.title);
//       }
//     }

//     const sections = ['hero', 'about', 'offer', 'attractions', 'contact'];

//     const handleScroll = () => {
//       if (location.pathname === '/') {
//         const scrollPosition = window.scrollY + 100;
//         for (let id of sections) {
//           const el = document.getElementById(id);
//           if (el && el.offsetTop <= scrollPosition && (el.offsetTop + el.offsetHeight) > scrollPosition) {
//             setActiveSection(id);
//             break;
//           }
//         }
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     handleScroll(); // Wywołaj raz na początku

//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [location]);

//   return (
//     <>
//       <Navbar activeSection={activeSection} />
//       {children}
//       <Footer />
//     </>
//   );
// };

// const HomePage = () => {
//   return (
//     <>
//       <div id="hero"><Hero /></div>
//       <div id="about"><About /></div>
//       <div id="offer"><Offer /></div>
//       <div id="attractions"><Attractions /></div>
//       <div id="contact"><Contact /></div>
//     </>
//   );
// };

// // Komponent dla podstron z Navbarem
// const PageLayout = ({ children }) => {
//   return (
//     <>
//       <Navbar activeSection="" />
//       <main className="pt-20"> {/* Dodaj padding-top aby kompensować wysokość Navbar */}
//         {children}
//       </main>
//       <Footer />
//     </>
//   );
// };

// function App() {
//   return (
//     <Router>
//       <div className="font-sans text-gray-800 bg-[#edece8]">
//         <Routes>
//           <Route path="/" element={
//             <ScrollHandler>
//               <HomePage />
//             </ScrollHandler>
//           } />
//           <Route path="/cennik" element={
//             <PageLayout>
//               <Pricing />
//             </PageLayout>
//           } />
//           <Route path="/atrakcje" element={
//             <PageLayout>
//               <AttractionsDetails />
//             </PageLayout>
//           } />
//           <Route path="/admin/AdminAboutPanel" element={<AdminAboutPanel />} />
//           <Route path="/admin/AdminHeroPanel" element={<AdminHeroPanel />} />
//           <Route path="/admin/AdminOfferPanel" element={<AdminOfferPanel />} />
//           <Route path="/admin/AdminPricingPanel" element={<AdminPricingPanel />} />
//           <Route path="/admin/AdminAttractionsPanel" element={<AdminAttractionsPanel />} />
//           <Route path="/admin/AdminContactPanel" element={<AdminContactPanel />} />
//           <Route path="/admin/AdminPanelWithStyles" element={<AdminPanelWithStyles />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;


import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import './index.css';
import Offer from './components/Offer';
import Pricing from './components/Pricing';
import Attractions from './components/Attractions';
import AttractionsDetails from './components/AttractionsDetails';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminAboutPanel from './components/AdminAboutPanel';
import AdminHeroPanel from './components/AdminHeroPanel';
import AdminOfferPanel from './components/AdminOfferPanel';
import AdminPricingPanel from './components/AdminPricingPanel';
import AdminAttractionsPanel from './components/AdminAttractionsPanel';
import AdminContactPanel from './components/AdminContactPanel';
import AdminMenuPanel from './components/AdminMenuPanel';
import AdminLoginPanel from './components/AdminLoginPanel';
import AdminRoute from './components/AdminRoute';
import PrivacyPolicy from './components/PrivacyPolicy';

const ScrollHandler = ({ children }) => {
  const [activeSection, setActiveSection] = useState('');
  const location = useLocation();

  useEffect(() => {
    // Obsługa automatycznego przewijania po nawigacji z innej strony
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
        // Wyczyść stan, aby nie przewijać za każdym razem
        window.history.replaceState({}, document.title);
      }
    }

    const sections = ['hero', 'about', 'offer', 'attractions', 'contact'];

    const handleScroll = () => {
      if (location.pathname === '/') {
        const scrollPosition = window.scrollY + 100;
        for (let id of sections) {
          const el = document.getElementById(id);
          if (el && el.offsetTop <= scrollPosition && (el.offsetTop + el.offsetHeight) > scrollPosition) {
            setActiveSection(id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Wywołaj raz na początku

    return () => window.removeEventListener('scroll', handleScroll);
  }, [location]);

  return (
    <>
      <Navbar activeSection={activeSection} />
      {children}
      <Footer />
    </>
  );
};

const HomePage = () => {
  return (
    <>
      <div id="hero"><Hero /></div>
      <div id="about"><About /></div>
      <div id="offer"><Offer /></div>
      <div id="attractions"><Attractions /></div>
      <div id="contact"><Contact /></div>
    </>
  );
};

// Komponent dla podstron z Navbarem
const PageLayout = ({ children }) => {
  return (
    <>
      <Navbar activeSection="" />
      <main className="pt-20"> {/* Dodaj padding-top aby kompensować wysokość Navbar */}
        {children}
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="font-sans text-gray-800 bg-[#edece8]">
        <Routes>
          {/* Publiczne route */}
          <Route path="/" element={
            <ScrollHandler>
              <HomePage />
            </ScrollHandler>
          } />
          <Route path="/cennik" element={
            <PageLayout>
              <Pricing />
            </PageLayout>
          } />
          <Route path="/atrakcje" element={
            <PageLayout>
              <AttractionsDetails />
            </PageLayout>
          } />
          <Route path="/PolitykaPrywatnosci" element={
            <PageLayout>
              <PrivacyPolicy />
            </PageLayout>
          } />
          
          {/* Strona logowania */}
          <Route path="/admin/login" element={<AdminLoginPanel />} />
          
          {/* Zabezpieczone route panelu admina */}
          <Route path="/admin/AdminAboutPanel" element={
            <AdminRoute>
              <AdminAboutPanel />
            </AdminRoute>
          } />
          <Route path="/admin/AdminHeroPanel" element={
            <AdminRoute>
              <AdminHeroPanel />
            </AdminRoute>
          } />
          <Route path="/admin/AdminOfferPanel" element={
            <AdminRoute>
              <AdminOfferPanel />
            </AdminRoute>
          } />
          <Route path="/admin/AdminPricingPanel" element={
            <AdminRoute>
              <AdminPricingPanel />
            </AdminRoute>
          } />
          <Route path="/admin/AdminAttractionsPanel" element={
            <AdminRoute>
              <AdminAttractionsPanel />
            </AdminRoute>
          } />
          <Route path="/admin/AdminContactPanel" element={
            <AdminRoute>
              <AdminContactPanel />
            </AdminRoute>
          } />
          <Route path="/admin/AdminMenuPanel" element={
            <AdminRoute>
              <AdminMenuPanel />
            </AdminRoute>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;